import React from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';

const LayoutContainer = styled.div`
  display: flex;
`;

const MainContent = styled.main`
  margin-left: 250px;
  padding: 80px 30px 30px;
  width: calc(100% - 250px);
  min-height: 100vh;
  background-color: #f8f9fa;
`;

interface LayoutProps {
  children: React.ReactNode;
  companyName?: string;
  sector?: string;
  location?: string;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  companyName, 
  sector, 
  location 
}) => {
  return (
    <LayoutContainer>
      <Sidebar />
      <Header 
        companyName={companyName} 
        sector={sector} 
        location={location} 
      />
      <MainContent>
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
